import React, { useState, useMemo } from 'react';
import { Chart } from 'react-charts';
import {
  horizontalCurveData,
  linearCurveData,
  quadraticCurveData,
  sigmoidCurveData,
} from "./chartsData";
import './CreatorUploadMonetizationForm.css';

function CreatorMonetizationMintPriceLiquidForm(props) {
  const [curve, setCurve] = useState(props.params && props.params.curve ? props.params.curve : "");
  const [interceptPolynomial, setInterceptPolynomial] = useState(props.params && props.params.curve ? props.params.curve : "");
  const [linearTermPolynomial, setLinearTermPolynomial] = useState(props.params && props.params.linearTermPolynomial ? props.params.linearTermPolynomial : "");
  const [quadraticTermPolynomial, setQuadraticTermPolynomial] = useState(props.params && props.params.quadraticTermPolynomial ? props.params.quadraticTermPolynomial : "");
  const [sigmoidGrowth, setSigmoidGrowth] = useState(props.params && props.params.sigmoidGrowth ? props.params.sigmoidGrowth : "");
  const [sigmoidPriceRange, setSigmoidPriceRange] = useState(props.params && props.params.sigmoidPriceRange ? props.params.sigmoidPriceRange : "");
  const [sigmoidInflectionPoint, setSigmoidInflectionPoint] = useState(props.params && props.params.sigmoidInflectionPoint ? props.params.sigmoidInflectionPoint : "");
  const [sigmoidCurveAdjustment, setSigmoidCurveAdjustment] = useState(props.params && props.params.sigmoidCurveAdjustment ? props.params.sigmoidCurveAdjustment : "");

  async function handleCurveChange(curve) {
    setCurve(curve);
    props.setCurve(curve);
  }

  async function handleInterceptPolynomialChange(event) {
    if(props.checkStringWithDecimal(event.target.value) || event.target.value === "") {
      setInterceptPolynomial(event.target.value);
      props.setInterceptPolynomial(event.target.value);
    }
  }

  async function handleLinearTermPolynomialChange(event) {
    if(props.checkStringWithDecimal(event.target.value) || event.target.value === "") {
      setLinearTermPolynomial(event.target.value);
      props.setLinearTermPolynomial(event.target.value);
    }
  }

  async function handleQuadraticTermPolynomialChange(event) {
    if(props.checkStringWithDecimal(event.target.value) || event.target.value === "") {
      setQuadraticTermPolynomial(event.target.value);
      props.setQuadraticTermPolynomial(event.target.value);
    }
  }

  async function handleSigmoidGrowthChange(event) {
    if(props.checkString(event.target.value) || event.target.value === "") {
      setSigmoidGrowth(event.target.value);
      props.setSigmoidGrowth(event.target.value);
    }
  }

  async function handleSigmoidPriceRangeChange(event) {
    if(props.checkString(event.target.value) || event.target.value === "") {
      setSigmoidPriceRange(event.target.value);
      props.setSigmoidPriceRange(event.target.value);
    }
  }

  async function handleSigmoidInflectionPointChange(event) {
    if(props.checkString(event.target.value) || event.target.value === "") {
      setSigmoidInflectionPoint(event.target.value);
      props.setSigmoidInflectionPoint(event.target.value);
    }
  }

  async function handleSigmoidCurveAdjustmentChange(event) {
    if(props.checkString(event.target.value) || event.target.value === "") {
      setSigmoidCurveAdjustment(event.target.value);
      props.setSigmoidCurveAdjustment(event.target.value);
    }
  }

  const primaryAxis = useMemo(
    (): AxisOptions<MyDatum> => ({
      getValue: datum => datum.x,
    }),
    []
  )
 
  const secondaryAxes = useMemo(
    (): AxisOptions<MyDatum>[] => [
      {
        getValue: datum => datum.y,
      },
    ],
    []
  )
  const horizontalLine = (
    <div
      style={{
        width: '96px',
        height: '96px'
      }}
    >
      <Chart
         options={{
           data: horizontalCurveData,
           primaryAxis,
           secondaryAxes,
         }}
       />
     </div>
  );
  const linearLine = (
    <div
      style={{
        width: '96px',
        height: '96px'
      }}
    >
      <Chart
         options={{
           data: linearCurveData,
           primaryAxis,
           secondaryAxes,
         }}
       />
     </div>
  );
  const quadraticLine = (
    <div
      style={{
        width: '96px',
        height: '96px'
      }}
    >
      <Chart
         options={{
           data: quadraticCurveData,
           primaryAxis,
           secondaryAxes,
         }}
       />
     </div>
  );
  const sigmoidLine = (
    <div
      style={{
        width: '96px',
        height: '96px'
      }}
    >
      <Chart
         options={{
           data: sigmoidCurveData,
           primaryAxis,
           secondaryAxes,
         }}
       />
     </div>
  );

  return (
    <div>
      <div className="text-black dark:text-white font-semibold mt-8">
        Choose your curve
      </div>
      <div className="flex justify-between mt-2">
        <div className="flex">
          <input
            type="checkbox"
            checked={curve === "Horizontal"}
            onChange={() => handleCurveChange("Horizontal")}
          />
          <div className="ml-2 flex flex-col items-center ">
            <div className="bg-gray-300 w-24 h-24">
              {horizontalLine}
            </div>
            <div className="text-black dark:text-white">
              Horizontal
            </div>
          </div>
        </div>
        <div className="flex">
          <input
            type="checkbox"
            checked={curve === "Linear"}
            onChange={() => handleCurveChange("Linear")}
          />
          <div className="ml-2 flex flex-col items-center ">
            <div className="bg-gray-300 w-24 h-24">
              {linearLine}
            </div>
            <div className="text-black dark:text-white">
              Linear
            </div>
          </div>
        </div>
        <div className="flex">
          <input
            type="checkbox"
            checked={curve === "Quadratic"}
            onChange={() => handleCurveChange("Quadratic")}
          />
          <div className="ml-2 flex flex-col items-center ">
            <div className="bg-gray-300 w-24 h-24">
              {quadraticLine}
            </div>
            <div className="text-black dark:text-white">
              Quadratic
            </div>
          </div>
        </div>
        <div className="flex">
          <input
            type="checkbox"
            checked={curve === "Sigmoid"}
            onChange={() => handleCurveChange("Sigmoid")}
          />
          <div className="ml-2 flex flex-col items-center ">
            <div className="bg-gray-300 w-24 h-24">
              {sigmoidLine}
            </div>
            <div className="text-black dark:text-white">
              Sigmoid
            </div>
          </div>
        </div>
      </div>
      {
        curve === "Horizontal"
          ?
        <div className="mt-8">
          <iframe src="https://www.desmos.com/calculator/wxd0bxbffj" width="100%" height="300px" />
        </div>
          :
        null
      }
      {
        curve === "Linear"
          ?
        <div className="mt-8">
          <iframe src="https://www.desmos.com/calculator/ajx0gjnbzf" width="100%" height="300px" />
        </div>
          :
        null
      }
      {
        curve === "Quadratic"
          ?
        <div className="mt-8">
          <iframe src="https://www.desmos.com/calculator/f0lwxfpuus" width="100%" height="400px" />
        </div>
          :
        null
      }
      {
        curve === "Sigmoid"
          ?
        <div className="mt-8">
          <iframe src="https://www.desmos.com/calculator/obtedzkrdr" width="100%" height="500px" />
        </div>
          :
        null
      }
      {
        curve !== "" && curve !== "Horizontal"
          ?
        <div>
          <label className="text-black">
            <input
              placeholder="Price growth - (the A variable)"
              value={
                curve === "Linear"
                  ?
                linearTermPolynomial
                  :
                curve === "Quadratic"
                  ?
                quadraticTermPolynomial
                  :
                sigmoidGrowth
              }
              onChange={
                curve === "Linear"
                  ?
                handleLinearTermPolynomialChange
                  :
                curve === "Quadratic"
                  ?
                handleQuadraticTermPolynomialChange
                  :
                handleSigmoidGrowthChange
              }
              className = "placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
              type="text"
            />
          </label>
          How steep you would like the change in price to be. The higher the "A", the faster your price will change.
        </div>
          :
        null
      }
      {
        curve === "Quadratic"
          ?
        <div>
          <label className="text-black">
            <input
              placeholder="Growth factor - (the B variable)"
              value={linearTermPolynomial}
              onChange={handleLinearTermPolynomialChange}
              className = "placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
              type="text"
            />
          </label>
          A secondary growth rate (we recommend keeping this at 0 for simplicity)
        </div>
          :
        null
      }
      {
        curve === "Sigmoid"
          ?
        <div>
          <label className="text-black">
            <input
              placeholder="The price range - (the B variable)"
              value={sigmoidPriceRange}
              onChange={handleSigmoidPriceRangeChange}
              className = "placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
              type="text"
            />
          </label>
          A measure of how high prices will go go- the higher the "B" the higher your ceiling price will be.
          <label className="text-black">
            <input
              placeholder="The inflection point - (the C variable)"
              value={sigmoidInflectionPoint}
              onChange={handleSigmoidInflectionPointChange}
              className = "placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
              type="text"
            />
          </label>
          The "inflection point" - the number of editions where the curve goes from increasing at an increasing rate to increasing at a decreasing rate.
          i.e. where the 2nd derivate goes from positive to negative
        </div>
          :
        null
      }
      {
        curve !== ""
          ?
        <div>
          <label className="text-black">
            <input
              placeholder={curve === "Sigmoid" ? "Curve adjustment - (the D variable)" : "Starting price - (the D variable)"}
              value={
                curve === "Sigmoid"
                  ?
                sigmoidCurveAdjustment
                  :
                interceptPolynomial
              }
              onChange={
                curve === "Sigmoid"
                  ?
                handleSigmoidCurveAdjustmentChange
                  :
                handleInterceptPolynomialChange
              }
              className = "placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900" type="text"
            />
          </label>
          {
            curve === "Sigmoid" && sigmoidCurveAdjustment !== "" && !isNaN(props.usdPrice)
              ?
            "$ " + (sigmoidCurveAdjustment * props.usdPrice).toFixed(2)
              :
            curve !== "" && curve !== "Sigmoid" && interceptPolynomial !== "" && !isNaN(props.usdPrice)
              ?
            "$ " + (interceptPolynomial * props.usdPrice).toFixed(2)
              :
            null
          }
          {
            interceptPolynomial !== "" && !isNaN(props.usdPrice)
              ?
            <br />
              :
            null
          }
          {
            curve === "Sigmoid"
              ?
            "How much the curve is shifted up in ETH units. Lets you tweak the initial price and ceiling"
              :
            "Starting price of your curve in ETH"
          }
        </div>
          :
        null
      }
    </div>
  );
}

export default CreatorMonetizationMintPriceLiquidForm;
